import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentUserService } from '@core/services';
import { AppRoutes, OmRolesEnum } from '@shared/enums';

export const mySuppliesGuard: CanActivateFn = async () => {
    const router = inject(Router);
    const currentUserService = inject(CurrentUserService);

    await currentUserService.initializeCurrentUser();
    const isCentralShippingUser = currentUserService.hasRole(OmRolesEnum.CENTRAL_SHIPPING_USER);
    const isAdministrator = currentUserService.hasRole(OmRolesEnum.CENTRAL_SHIPPING_ADMINISTRATOR);

    if (isCentralShippingUser && !isAdministrator) {
        router.navigate([AppRoutes.DASHBOARD]);
        return false;
    }

    return true;
};
